module.exports = __webpack_public_path__ + "img/bag-3.51fdd0d4.jpg";